// extracted by mini-css-extract-plugin
export default {"wave":"wave_wave__c2Ewd"};